











































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserStats, UserStatsRequest } from '@/data/models/userstats.model';
import DettaglioChiamateOperatore from './DettaglioChiamateOperatore.vue';
import { User } from '@/data/models/user.model';

@Component({
	components: {
	},
})
export default class TableStatOperatore extends Vue {
	@Prop({ default: () => [] }) stats!: UserStats;
	@Prop() request!: UserStatsRequest;
	@Prop({ default: false }) daily!: boolean;
	@Prop() operatore!: User;

	get riepilogoLabel() {
		const label = this.daily ? 'daily' : 'range';
		return `${this.$t('stats-operatore.riepilogo-chiamate')} ${this.$t('stats-operatore.' + label)}`;
	}

	constructor() {
		super();
	}

	openCallDetail() {
		this.$buefy.modal.open({
			parent: this,
			component: DettaglioChiamateOperatore,
			props: {
				operatore: this.operatore,
				daily: this.daily,
				request: this.request,
			},
			hasModalCard: true,
			canCancel: false,
		});
	}
}
